export function getAccessToken() {
    let access_token = localStorage.getItem("xplore_token") || ""
    return access_token
}

export function setAccessToken(access_token: string) {
    localStorage.setItem("xplore_token", access_token)
}

export function removeAccessToken() {
    localStorage.removeItem("xplore_token")
}

export function isSetAccessToken() {
    if ("xplore_token" in localStorage) {
        return true
    }

    return false
}


